module.exports = __webpack_public_path__ + "static/img/xxbj_jcjg_icon.png";